const mod = require('../../bahabot.module.js')

function bbChatController(EventSourceService, $sce, $scope, $timeout) {
    this.stream = null;
    this.subscriptions = [];
    this.messages = [];
    this.size = 100;
    this.model = {
        translationLanguage: "Off",
        showReadings: "Off"
    };

    const compileMessage = (message) => {
        // first make the entire thing safe
        const d = document.createElement('div');
        d.textContent = message.message;
        const safeContent = d.innerHTML;
        
        // and then we apply emotes where we can
        const compiledContent = safeContent.split(" ").map(part => {
            if (message.emotes[part]) {
                return `<img src="${message.emotes[part]}" alt="${part}" class="inline aspect-1/1 h-6" />`;
            }
            return part;
        }).join(" ")

        return {
            ...message,
            message: $sce.trustAsHtml(compiledContent)
        };
    }

    this.$onInit = () => {
        this.stream = EventSourceService.connect("/api/public/chat/live")
        let init = true;
        $timeout(() => {
            init = false;
            $scope.bottom[0].scrollIntoView({
                behavior: 'smooth'
            });
        }, 200)

        const offMessage = this.stream.on('message', (data) => {
            this.messages.push(compileMessage(data.chatMessage));
            if (!init) {
                $timeout(() => {
                    $scope.bottom[0].scrollIntoView({
                        behavior: 'smooth'
                    });
                }, 50);
            }
            while (this.messages.length > this.size) this.messages.shift();
        })
        const offClearAll = this.stream.on('clear_all', () => {
            this.messages = [];
        })
        const offClearOne = this.stream.on('clear_one', (data) => {
            this.messages = this.messages.filter(m => m.username === data.clearMessage.username);
        })

        this.subscriptions = [
            offMessage,
            offClearAll,
            offClearOne
        ]
    }

    this.$onDestroy = () => {
        for (const unregister of this.subscriptions) {
            unregister();
        }
        this.subscriptions = [];
        this.messages = [];
        this.stream?.close();
        this.stream = null;
    }
}

mod.component('bbChat', {
    templateUrl: 'tpl/bb-chat.component.html',
    bindings: {},
    controller: ["EventSourceService", "$sce", "$scope", "$timeout", bbChatController]
});